// Centers axes when answer has no xTitle / yTitle.
// Called from Highcharts chart.events.load (via bubbleConfig).
// Port of quadrant.coffee L79-110 — replacing d3 select/attr with direct DOM setAttribute.

/**
 * @param {Highcharts.Chart} chart
 * @param {Object} answer - { xTitle?, yTitle? }
 */
export const centerQuadrantAxes = (chart, answer) => {
  const { chartWidth, chartHeight, axes } = chart
  const xAxis = axes?.[0]
  const yAxis = axes?.[1]

  // X axis — center vertically
  if (!answer?.xTitle && xAxis?.axisGroup?.element) {
    xAxis.axisGroup.element.setAttribute('transform', `translate(0, ${chartHeight / 2})`)
  }
  if (!answer?.xTitle && xAxis?.axisTitle?.element) {
    xAxis.axisTitle.element.setAttribute('dx', '-2')
  }
  if (!answer?.xTitle && xAxis?.labelGroup?.element) {
    const g = xAxis.labelGroup.element
    g.setAttribute('transform', `translate(0, ${chartHeight / 2})`)

    const nodes = g.childNodes
    if (nodes.length > 0) {
      const first = nodes[0]
      const last = nodes[nodes.length - 1]
      first.setAttribute('dx', String(5 * first.textContent.length))
      last.setAttribute('dx', String(-5 * last.textContent.length))
    }
  }

  // Y axis — center horizontally
  if (!answer?.yTitle && yAxis?.axisGroup?.element) {
    yAxis.axisGroup.element.setAttribute('transform', `translate(${chartWidth / 2}, 0)`)
  }
  if (!answer?.yTitle && yAxis?.axisTitle?.element) {
    yAxis.axisTitle.element.setAttribute('dx', '-2')
  }
  if (!answer?.yTitle && yAxis?.labelGroup?.element) {
    const g = yAxis.labelGroup.element
    g.setAttribute('transform', `translate(${chartWidth / 2}, 0)`)

    const nodes = g.childNodes
    if (nodes.length > 0) {
      const first = nodes[0]
      const last = nodes[nodes.length - 1]
      first.setAttribute('dx', String(5 * first.textContent.length))
      last.setAttribute('dx', String(-5 * last.textContent.length))
    }
  }
}
